import {
  Group,
  Object3D,
  PlaneGeometry,
  EdgesGeometry,
  LineSegments,
  LineBasicMaterial,
  LineDashedMaterial,
  MeshBasicMaterial,
  Mesh,
  EqualStencilFunc,
} from 'three';
import {
  phantomMat,
  plotnoMat,
  plotnoMatInterior,
  plotnoMatDark,
  whiteMat,
  metals,
} from './Materials';
import Dimension from './Dimension';

export default class Body {
  constructor(wardrobeConfig, gltf) {
    this.gltf = gltf;

    const aName = wardrobeConfig.safo.split('/');

    this.width = 100;
    this.type = aName[0];
    this.height = parseInt(wardrobeConfig.dimensions.y);
    this.depth = 66;
    this.verticalDivide = 57;

    this.makeBody(wardrobeConfig);
    this.changeMaterial(whiteMat);
  }

  makeBody(wardrobeConfig) {
    switch (this.type) {
      case 'F57-SZFN1D':
        this.width = 103;
        this.depth = 103;
        this.height = parseInt(wardrobeConfig.dimensions.y);
        break;
      case 'F57-SZF1DL':
        this.width = 97;
        this.height = parseInt(wardrobeConfig.dimensions.y);
        this.depth = parseInt(wardrobeConfig.dimensions.z);
        break;
      case 'F57-SZF1DR':
        this.width = 97;
        this.height = parseInt(wardrobeConfig.dimensions.y);
        this.depth = parseInt(wardrobeConfig.dimensions.z);
        break;
      default:
        this.width = parseInt(wardrobeConfig.dimensions.x);
        this.height = parseInt(wardrobeConfig.dimensions.y);
        this.depth = parseInt(wardrobeConfig.dimensions.z);
    }

    this.newBody = new Group();
    this.RAM_Top = new Object3D();
    this.Phantom = new Object3D();
    this.Korpus_Top = new Object3D();
    this.Korpus_Bottom = new Object3D();
    this.Korpus_Left = new Object3D();
    this.Korpus_Right = new Object3D();
    this.Interior_Back = new Object3D();
    this.Interior_Back2 = new Object3D();
    this.Interior_Mid_H1 = new Object3D();
    this.Interior_Mid_H2 = new Object3D();
    this.Interior_Mid_V1 = new Object3D();
    this.Interior_Mid_V2 = new Object3D();
    this.Interior_Mid_V3 = new Object3D();

    this.zones = new Object3D();
    this.zoneDashes = new Group();
    this.zoneOutlines = new Group();
    this.zones.name = 'Zones';
    this.makeZone('left');
    this.makeZone('center');
    this.makeZone('right');

    if (this.type === 'F57-SZFN1D') {
      this.zones.rotation.y = (-45 * Math.PI) / 180;
    }

    if (this.type === 'F57-SZF1DR') {
      this.zones.rotation.y = (-90 * Math.PI) / 180;
    }

    this.zones.add(this.zoneDashes);
    this.zones.add(this.zoneOutlines);

    this.gltf.traverse(obj => {
      if (this.type === 'F57-SZFN1D') {
        obj.name === 'Phantom' && (this.Phantom = obj);
      } else {
        obj.name === 'Phantom_Box' && (this.Phantom = obj);
      }

      if (obj.name === 'Korpus_Left') {
        this.Korpus_Left = new Group();
        this.Korpus_Left.add(obj.clone());
        this.newBody.add(this.Korpus_Left);
      }
      if (obj.name === 'Shadow_Korpus_Left') {
        this.Korpus_Left.add(obj.clone());
      }

      if (obj.name === 'Korpus_Right') {
        this.Korpus_Right = new Group();
        this.Korpus_Right.add(obj.clone());
        this.newBody.add(this.Korpus_Right);
      }
      if (obj.name === 'Shadow_Korpus_Right') {
        this.Korpus_Right.add(obj.clone());
      }

      if (obj.name === 'Interior_Back') {
        this.Interior_Back = obj.clone();
        this.Interior_Back.material = plotnoMatInterior;
        this.newBody.add(this.Interior_Back);

        this.Interior_Back2 = obj.clone();
        this.Interior_Back2.material = plotnoMatInterior;
        this.Interior_Back2.name = 'Interior_Back2';
        this.Interior_Back2.position.x = this.width - 2;
        this.Interior_Back2.rotation.y = (Math.PI / 180) * 90;
        this.Interior_Back2.position.z = 34;
        this.Interior_Back2.scale.set(100, this.height - 2, 100);
        this.newBody.add(this.Interior_Back2);
      }

      if (obj.name === 'Interior_Mid_H') {
        obj.material = plotnoMatInterior;
        this.Interior_Mid_H1 = obj.clone();
        this.newBody.add(this.Interior_Mid_H1);
        this.Interior_Mid_H2 = obj.clone();
        this.newBody.add(this.Interior_Mid_H2);
        this.Interior_Mid_H2.name = 'Interior_Mid_H2';
        this.Interior_Mid_H3 = obj.clone();
        this.Interior_Mid_H3.name = 'Interior_Mid_H3';
        this.newBody.add(this.Interior_Mid_H3);
        this.Interior_Mid_H3.scale.set(39, 100, 100);
        this.Interior_Mid_H3.position.set(0, 36, 0);
        this.Interior_Mid_H4 = obj.clone();
        this.Interior_Mid_H4.name = 'Interior_Mid_H4';
        this.newBody.add(this.Interior_Mid_H4);
        this.Interior_Mid_H4.scale.set(39, 100, 100);
        this.Interior_Mid_H4.position.set(0, 71, 0);
        this.Interior_Mid_H5 = obj.clone();
        this.Interior_Mid_H5.name = 'Interior_Mid_H5';
        this.newBody.add(this.Interior_Mid_H5);
        this.Interior_Mid_H5.scale.set(39, 100, 100);
        this.Interior_Mid_H5.position.set(0, 106, 0);
        this.Interior_Mid_H6 = obj.clone();
        this.Interior_Mid_H6.name = 'Interior_Mid_H6';
        this.newBody.add(this.Interior_Mid_H6);
        this.Interior_Mid_H6.scale.set(39, 100, 100);
        this.Interior_Mid_H6.position.set(0, 142, 0);
        this.Interior_Mid_H7 = obj.clone();
        this.Interior_Mid_H7.name = 'Interior_Mid_H7';
        this.Interior_Mid_H7.scale.set(39, 100, 100);
        this.Interior_Mid_H7.position.set(0, 206, 0);
        if (this.height < 240) {
          this.Interior_Mid_H7.visible = false;
        }
        this.newBody.add(this.Interior_Mid_H7);
      }
      if (obj.name === 'Interior_Mid_V') {
        obj.material = plotnoMatInterior;
        this.Interior_Mid_V1 = obj.clone();
        this.Interior_Mid_V1.name = 'Interior_Mid_V1';
        this.newBody.add(this.Interior_Mid_V1);
        this.Interior_Mid_V2 = obj.clone();
        this.Interior_Mid_V2.name = 'Interior_Mid_V2';
        this.newBody.add(this.Interior_Mid_V2);
        this.Interior_Mid_V3 = obj.clone();
        this.Interior_Mid_V3.name = 'Interior_Mid_V3';
        this.newBody.add(this.Interior_Mid_V3);
      }
      if (obj.name === 'Korpus_N_Top') {
        this.Korpus_N_Bottom = new Group();
        this.Korpus_N_Bottom.add(obj.clone());
        this.newBody.add(this.Korpus_N_Bottom);

        this.Korpus_N_Top = new Group();
        this.Korpus_N_Top.add(obj.clone());
        this.newBody.add(this.Korpus_N_Top);
      }
      if (obj.name === 'Shadow_Korpus_N_Top') {
        this.Korpus_N_Top.add(obj.clone());
        this.Korpus_N_Bottom.add(obj.clone());
      }
      if (obj.name === 'Korpus_N_Front') {
        this.Korpus_N_Front = new Group();
        this.Korpus_N_Front.add(obj.clone());
        this.Korpus_N_Front.name = 'Korpus_N_Front';
        this.Korpus_N_Front.scale.set(100, this.height - 1, 100);
        this.newBody.add(this.Korpus_N_Front);
      }
      if (obj.name === 'Shadow_Korpus_N_Front') {
        this.Korpus_N_Front.add(obj.clone());
      }
      if (obj.name === 'Korpus_Top') {
        this.Korpus_Top = new Group();
        this.Korpus_Top.add(obj.clone());
        this.newBody.add(this.Korpus_Top);

        this.Korpus_Bottom = new Group();
        this.Korpus_Bottom.add(obj.clone());
        this.newBody.add(this.Korpus_Bottom);
      }
      if (obj.name === 'Shadow_Korpus_Top') {
        this.Korpus_Top.add(obj.clone());
        this.Korpus_Bottom.add(obj.clone());
      }

      if (obj.name === 'Wieszak') {
        for (let i = 0; i < 4; i++) {
          let wieszak = obj.clone();
          wieszak.name = 'Wieszak_' + i;
          wieszak.material = metals.SRE;
          wieszak.position.y = 175;
          wieszak.scale.set(100, 100, 100);
          this.newBody.add(wieszak);
        }
      }
    });
  }

  makeZone(zName) {
    var geometry = new PlaneGeometry(1, 4);
    let geo = new EdgesGeometry(geometry);
    var zone = new LineSegments(geo);
    zone.material = new LineDashedMaterial({
      color: 0x000000,
      linewidth: 1,
      scale: 1,
      dashSize: 0.05,
      gapSize: 0.05,
    });

    zone.name = zName + '_plane';

    var planeGeometry = new PlaneGeometry(1, 4);
    var mat = new MeshBasicMaterial({
      color: 0xffffff,
      opacity: 0,
      transparent: true,
      depthTest: false,
    });
    var plane = new Mesh(planeGeometry, mat);
    plane.position.z = 0.01;

    plane.name = zName;

    var outline = new LineSegments(geo);
    outline.material = new LineBasicMaterial({ color: 0xff0000 });
    outline.position.z = 0.01;

    outline.name = zName + '_outline';

    this.zones.add(plane);
    this.zoneDashes.add(zone);
    this.zoneOutlines.add(outline);

    zone.computeLineDistances();
  }

  getBody() {
    return this.newBody;
  }

  getZones() {
    return this.zones;
  }

  getPhantom() {
    this.Phantom.material = phantomMat.clone();
    return this.Phantom;
  }

  getWidth() {
    return this.width;
  }

  setBody(wardrobeConfig) {
    this.setDimensions(wardrobeConfig);

    const dimensions = wardrobeConfig.dimensions;

    this.Phantom.scale.set(dimensions.x + 10, dimensions.y + 1, dimensions.z);

    /* KORPUS */
    this.Korpus_N_Top.position.y = dimensions.y;
    this.Korpus_Top.position.y = dimensions.y;
    this.Korpus_Top.scale.set(dimensions.x, 100, dimensions.z);
    this.Korpus_Bottom.scale.set(dimensions.x, 100, dimensions.z);

    this.Korpus_Left.scale.set(100, dimensions.y - 2, dimensions.z);
    this.Korpus_Right.position.x = dimensions.x;
    this.Korpus_Right.scale.set(100, dimensions.y - 2, dimensions.z);

    /* INTERIOR */
    this.Interior_Back.scale.set(dimensions.x, dimensions.y - 2, 100);
    this.Interior_Back.position.z = -dimensions.z + 1;

    this.Interior_Mid_H1.position.y = 176;
    this.Interior_Mid_H1.scale.set(dimensions.x, 100, 100);

    for (let i = 0; i < 4; i++) {
      this.newBody.getObjectByName('Wieszak_' + i).visible = dimensions.z < 66;
      this.newBody.getObjectByName('Wieszak_' + i).position.x = (dimensions.x / 4) * i + 30;
      if (dimensions.x < 220) {
        this.newBody.getObjectByName('Wieszak_3').visible = false;
        this.newBody.getObjectByName('Wieszak_' + i).position.x = (dimensions.x / 3) * i + 30;
      }
      if (dimensions.x < 170) {
        this.newBody.getObjectByName('Wieszak_' + i).position.x =
          (dimensions.x / 2) * i + dimensions.x / 4;
        this.newBody.getObjectByName('Wieszak_2').visible = false;
      }
      if (dimensions.x < 100) {
        this.newBody.getObjectByName('Wieszak_0').position.x = dimensions.x / 2;
        this.newBody.getObjectByName('Wieszak_1').visible = false;
      }
    }

    /* INTERIOR MIDS */
    this.Interior_Mid_V1.position.x = 58;

    if (dimensions.y > 218) {
      this.Interior_Mid_H2.position.y = 208;
      this.Interior_Mid_H2.scale.set(dimensions.x, 100, 100);
      this.Interior_Mid_H2.visible = true;
    } else {
      this.Interior_Mid_H2.visible = false;
      this.Interior_Mid_H3.visible = false;
    }
    if (dimensions.x > 100) {
      this.Interior_Mid_V1.scale.set(100, dimensions.y, 100);
      if (dimensions.x > 180) {
        this.Interior_Mid_V2.scale.set(100, dimensions.y, 100);
        this.Interior_Mid_V2.position.x = dimensions.x - 58;
      }
    } else {
      this.Interior_Mid_V1.visible = false;
      this.Interior_Mid_V2.visible = false;
      this.Interior_Mid_V3.visible = false;
    }

    if (dimensions.x === 100) {
      this.Interior_Mid_V1.visible = true;
      this.Interior_Mid_V1.scale.set(100, dimensions.y, 100);
      this.Interior_Mid_V1.position.set(50, 0, 0);
      this.Interior_Mid_V2.visible = false;
    }

    if (dimensions.x > 103) {
      this.Interior_Mid_V1.visible = true;
      this.Interior_Mid_V2.visible = false;
      this.Interior_Mid_V3.visible = false;
    }

    if (dimensions.x < 120) {
      this.Interior_Mid_H1.position.z = 10;
      this.Interior_Mid_H2.position.z = 10;
      this.Interior_Mid_V1.position.z = 10;
    } else {
      this.Interior_Mid_H1.position.z = 0;
      this.Interior_Mid_H2.position.z = 0;
      this.Interior_Mid_V1.position.z = 0;
    }

    if (dimensions.x === 150) {
      this.Interior_Mid_V2.visible = false;
      this.Interior_Mid_V3.visible = false;
    }

    if (dimensions.x > 151 && dimensions.x < 200) {
      this.Interior_Mid_V2.visible = false;
      this.Interior_Mid_V3.visible = true;
      this.Interior_Mid_V3.scale.set(100, dimensions.y - 176, 100);
      this.Interior_Mid_V3.position.x = dimensions.x - 57;
      this.Interior_Mid_V3.position.y = 175;
    } else {
      this.Interior_Mid_V3.visible = false;
    }

    if (dimensions.x > 200) {
      this.Interior_Mid_V1.visible = true;
      this.Interior_Mid_V2.visible = true;
      this.Interior_Mid_V3.visible = false;
    }

    if (dimensions.x > 201) {
      this.Interior_Mid_V2.visible = true;
      this.Interior_Mid_V3.visible = true;
      this.Interior_Mid_V3.scale.set(100, dimensions.y - 176, 100);
      this.Interior_Mid_V3.position.x = dimensions.x / 2;
      this.Interior_Mid_V3.position.y = 175;
    }

    if (this.type === 'F57-SZFN1D') {
      this.Interior_Mid_H3.visible = true;
      this.Interior_Mid_H4.visible = true;
      this.Interior_Mid_H5.visible = true;
      this.Interior_Mid_H6.visible = true;
      this.Interior_Mid_H7.visible = true;
      if (dimensions.y < 240) {
        this.Interior_Mid_H7.visible = false;
      }
    } else {
      this.Interior_Mid_H3.visible = false;
      this.Interior_Mid_H4.visible = false;
      this.Interior_Mid_H5.visible = false;
      this.Interior_Mid_H6.visible = false;
      this.Interior_Mid_H7.visible = false;
    }

    switch (this.type) {
      case 'F57-SZFN1D':
        this.Korpus_N_Top.visible = true;
        this.Korpus_N_Bottom.visible = true;
        this.Korpus_Top.visible = false;
        this.Korpus_Bottom.visible = false;
        this.Korpus_N_Top.scale.set(100, 100, 100);
        this.Korpus_N_Bottom.scale.set(100, 100, 100);
        this.Korpus_N_Bottom.position.y = 0;
        this.Korpus_Right.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_Left.scale.set(100, this.height + 2, 66);
        this.Korpus_Left.position.set(0, -2, 0);
        this.Korpus_Right.scale.set(100, this.height + 2, 66);
        this.Korpus_N_Front.visible = false;
        this.Interior_Back.visible = true;
        this.Interior_Back2.visible = true;
        this.Interior_Back2.position.x = 98;
        this.Interior_Back2.position.z = 35;
        this.Interior_Mid_V2.visible = false;
        this.Interior_Mid_V3.visible = false;
        this.Korpus_Right.position.set(35, -2, 35);
        this.Korpus_Left.rotation.y = 0;
        this.Interior_Back.position.set(0, 0, -64);
        this.Interior_Back.scale.set(this.width, dimensions.y - 2, 100);
        this.Interior_Back2.scale.set(this.width, dimensions.y - 2, 100);
        this.Interior_Mid_V1.visible = true;
        this.Interior_Mid_V1.scale.set(100, dimensions.y, 100);
        this.Interior_Mid_V1.position.z = 0;
        this.Interior_Mid_V1.position.x = 38;
        this.Interior_Mid_H1.position.set(39, 176, 51);
        this.Interior_Mid_H1.scale.set(61, 100, 168);
        this.Interior_Mid_H1.rotation.y = 0;
        this.Interior_Mid_H2.position.set(2, 176, -0.5);
        this.Interior_Mid_H2.rotation.y = 0;
        this.Interior_Mid_H2.scale.set(39, 100, 100);
        this.Interior_Mid_H2.visible = true;
        this.Interior_Mid_H1.visible = true;
        this.Phantom.scale.set(100, dimensions.y, 100);
        this.Phantom.position.x = 17;
        break;
      case 'F57-SZF1DL':
        this.Interior_Mid_H1.scale.set(97, 100, 100);
        this.Interior_Mid_H1.position.set(0, 176, 10);
        this.Interior_Mid_H2.position.set(0, 208, 10);
        this.Interior_Mid_H1.rotation.y = 0;
        this.Interior_Mid_H2.rotation.y = 0;
        this.Korpus_Top.visible = true;
        this.Korpus_Bottom.visible = true;
        this.Interior_Back.visible = true;
        this.Interior_Back2.visible = false;
        this.Korpus_N_Top.visible = false;
        this.Korpus_N_Bottom.visible = false;
        this.Korpus_Top.rotation.y = 0;
        this.Korpus_Bottom.rotation.y = 0;
        this.Korpus_Left.rotation.y = 0;
        this.Korpus_Right.rotation.y = 0;
        this.Korpus_Left.position.set(0, 0, 0);
        this.Korpus_Top.position.z = 0;
        this.Korpus_Top.position.x = 0;
        this.Korpus_Bottom.position.set(0, 0, 0);
        this.Interior_Back.scale.set(97, dimensions.y - 1, 100);
        this.Korpus_Top.scale.set(97, 100, 66);
        this.Korpus_Bottom.scale.set(97, 100, 66);
        this.Korpus_Right.position.set(97, 0, 0);
        this.Korpus_Right.scale.z = 66;
        this.Korpus_Left.scale.z = 66;
        this.Korpus_N_Front.position.x = 97;
        this.Korpus_N_Front.position.z = 0;
        this.Korpus_N_Front.visible = true;
        this.Korpus_N_Front.rotation.y = 0;
        break;
      case 'F57-SZF1DR':
        this.Interior_Mid_H1.scale.set(97, 100, 100);
        this.Interior_Mid_H1.position.set(-2, 176, -50);
        this.Interior_Mid_H1.scale.set(97, 100, 100);
        this.Interior_Mid_H1.rotation.y = (-90 * Math.PI) / 180;
        this.Interior_Mid_H2.scale.set(97, 100, 100);
        this.Interior_Mid_H2.rotation.y = (-90 * Math.PI) / 180;
        this.Interior_Mid_H2.position.set(-2, 208, -50);
        this.Korpus_N_Front.visible = true;
        this.Korpus_N_Top.visible = false;
        this.Korpus_N_Bottom.visible = false;
        this.Korpus_Top.visible = true;
        this.Korpus_Bottom.visible = true;
        this.Interior_Back.scale.set(97, dimensions.y, 100);
        this.Korpus_Top.scale.set(97, 100, 66);
        this.Korpus_Top.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_Bottom.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_Top.position.z = -48;
        this.Korpus_Bottom.position.z = -48;
        this.Korpus_Top.position.x = 4;
        this.Korpus_Bottom.position.x = 4;
        this.Korpus_Bottom.scale.set(97, 100, 66);
        this.Korpus_Left.position.set(4, 0, -46);
        this.Korpus_Left.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_Left.scale.z = 66;
        this.Korpus_Right.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_Right.position.set(4, 0, 48);
        this.Korpus_Right.scale.z = 66;
        this.Korpus_N_Front.position.set(4, 0, -2);
        this.Korpus_N_Front.rotation.y = (-Math.PI / 180) * 90;
        this.Korpus_N_Front.visible = true;
        this.Interior_Back2.visible = true;
        this.Interior_Back2.position.x = 68;
        this.Interior_Back2.position.z = 50;
        this.Interior_Back.visible = false;
        break;
      default:
        this.Korpus_N_Top.visible = false;
        this.Korpus_N_Bottom.visible = false;
        this.Korpus_N_Front.visible = false;
        this.Interior_Back2.visible = false;
        this.Korpus_Top.visible = true;
        this.Korpus_Bottom.visible = true;
        this.Korpus_Bottom.visible = true;
        this.Korpus_Right.position.z = 0;
        this.Korpus_Right.rotation.y = 0;
        this.Interior_Mid_H1.position.x = 0;
        this.Korpus_Bottom.rotation.y = 0;
        this.Korpus_Top.rotation.y = 0;
        this.Korpus_Left.rotation.y = 0;
        this.Korpus_Right.rotation.y = 0;
        this.Interior_Mid_H1.rotation.y = 0;
        this.Interior_Mid_H2.rotation.y = 0;
        break;
    }

    /* ZONES */

    this.zones.traverse(zone => {
      if (zone.type === 'Mesh' || zone.type === 'LineSegments') {
        let aName = zone.name.split('_');
        let zoneScale = this.calculateZone(dimensions, aName[0]).scale;
        let zonePosition = this.calculateZone(dimensions, aName[0]).position;
        let zoneVisibility = this.calculateZone(dimensions, aName[0]).visibility;
        zone.scale.set(zoneScale[0], zoneScale[1], zoneScale[2]);
        zone.position.set(zonePosition[0], zonePosition[1], zonePosition[2]);
        if (aName[1] === 'outline') {
          zone.visible = false;
        } else {
          zone.visible = zoneVisibility;
        }
      }
    });
  }

  calculateZone(dimensions, side) {
    let scale = { x: 1, y: 1, z: 1 };
    let position = { x: 0, y: 0, z: 0 };
    let visibility = true;
    switch (side) {
      case 'left':
        scale.x = this.verticalDivide - 4;
        scale.y = dimensions.y / 4 - 1;
        position.x = this.verticalDivide / 2;
        position.y = dimensions.y / 2 - 1;
        if (this.type === 'F57-SZFN1D') {
          scale.x = 45;
          position.x = 25;
        }
        if (dimensions.x === 50) {
          position.x = 24;
          scale.x = 46;
        }
        if (dimensions.x === 75) {
          position.x = 37;
          scale.x = 69;
        }
        if (dimensions.x === 100) {
          position.x = 24;
          scale.x = 45;
        }
        break;
      case 'center':
        scale.x = dimensions.x - this.verticalDivide * 2 - 4;
        scale.y = dimensions.y / 4 - 1;
        position.y = dimensions.y / 2 - 1;
        position.x = dimensions.x / 2;
        position.z = -1;
        if (dimensions.x < 200) {
          visibility = false;
        }
        break;
      case 'right':
        scale.x = this.verticalDivide - 4;
        scale.y = dimensions.y / 4 - 1;
        position.x = dimensions.x - this.verticalDivide;
        position.y = dimensions.y / 2 - 1;
        if (this.width < 200) {
          scale.x = dimensions.x - this.verticalDivide - 4;
          if (this.width <= 120) {
            position.x = dimensions.x - this.verticalDivide / 2 - 4;
          } else {
            position.x = dimensions.x - this.verticalDivide - 4 - 1;
          }
        } else {
          position.x = dimensions.x - this.verticalDivide / 2;
        }
        if (
          dimensions.x < 100 ||
          this.type === 'F57-SZFN1D' ||
          this.type === 'F57-SZF1DL' ||
          this.type === 'F57-SZF1DR'
        ) {
          visibility = false;
        }
        if (dimensions.x === 100) {
          position.x = 75;
          scale.x = 45;
        }
        if (this.width === 150) {
          position.x = 101;
        }
        break;
      default:
    }

    return {
      scale: [scale.x, scale.y, scale.z],
      position: [position.x, position.y, position.z],
      visibility: visibility,
    };
  }

  setDimensions(wardrobeConfig) {
    const aName = wardrobeConfig.safo.split('/');

    this.width = 100;
    this.type = aName[0];
    this.height = parseInt(wardrobeConfig.dimensions.y);
    this.depth = 66;

    switch (this.type) {
      case 'F57-SZFN1D':
        this.width = 103;
        this.depth = 103;
        this.height = parseInt(wardrobeConfig.dimensions.y);
        break;
      default:
        this.width = parseInt(wardrobeConfig.dimensions.x);
        this.height = parseInt(wardrobeConfig.dimensions.y);
        this.depth = parseInt(wardrobeConfig.dimensions.z);
    }
  }

  changeMaterial(material) {
    this.Korpus_N_Top.children[0].material = material;
    this.Korpus_N_Bottom.children[0].material = material;
    this.Korpus_Top.children[0].material = material;
    this.Korpus_Bottom.children[0].material = material;
    this.Korpus_Left.children[0].material = material;
    this.Korpus_Right.children[0].material = material;
    this.Korpus_N_Front.children[0].material = material;
  }

  setBodyShadows(shadowMat) {
    this.Korpus_N_Top.children[1].material = shadowMat;
    this.Korpus_N_Bottom.children[1].material = shadowMat;
    this.Korpus_Left.children[1].material = shadowMat;
    this.Korpus_Right.children[1].material = shadowMat;
    this.Korpus_Top.children[1].material = shadowMat;
    this.Korpus_Bottom.children[1].material = shadowMat;
    this.Korpus_N_Front.children[1].material = shadowMat;
  }
}
